"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dompurify_1 = __importDefault(require("dompurify"));
/**
 * source: https://github.com/cure53/DOMPurify
 * We can add more configuration to the sanitizer config as a second paramater
 * or by using their custom hooks (e.g: https://github.com/cure53/DOMPurify/tree/master/demos).
 */
exports.default = (htmlData) => {
    dompurify_1.default.addHook('afterSanitizeAttributes', node => {
        // set all elements owning target to target=_blank
        if ('target' in node) {
            node.setAttribute('target', '_blank');
            // Consider all links as external links.
            if (node.hasAttribute('href')) {
                const href = node.getAttribute('href');
                if (!['http', 'tel:', 'mailto:'].some(s => href.startsWith(s))) {
                    node.setAttribute('href', `http://${href}`);
                }
            }
        }
        // set non-HTML/MathML links to xlink:show=new
        if (!node.hasAttribute('target') &&
            (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
            node.setAttribute('xlink:show', 'new');
        }
    });
    const cleanHTML = dompurify_1.default.sanitize(htmlData);
    return { __html: cleanHTML };
};
//# sourceMappingURL=displayHtml.js.map